import { Options } from '@angular-slider/ngx-slider';
import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningManagementService } from '../../e-learning-management/e-learning-management.service';
import { MeasureManagementService } from '../measure-management.service';
import * as tus from 'tus-js-client';
import { uploadFiles } from 'src/app/shared/models/uploadFiles.model';
import { of } from 'rxjs';

@Component({
  selector: 'app-modal-add-question',
  templateUrl: './modal-add-question.component.html',
  styleUrls: ['./modal-add-question.component.scss']
})
export class ModalAddQuestionComponent implements OnInit {
  isLoading: boolean;
  modalData: any;
  multipleChoiceForm: FormGroup;
  rankingForm: FormGroup;
  ratingForm: FormGroup;
  mostLeastForm: FormGroup;
  multiForm: FormGroup;
  type: string;
  subType: string;
  media: any;
  questionMediaType: string;
  questionMedia: any;
  choicesMedia = [];
  value: number;
  options: Options;
  isEdit: boolean;

  pendingFiles: uploadFiles[] = [];
  hashKey: string;
  uploadVideoUri: string;
  isUploadSuccess: boolean = false;
  percentage: number;

  questionType = [{
    name: 'Multiple Choice',
    value: 'multi_choice'
  }, {
    name: 'Rating',
    value: 'rating'
  }, {
    name: 'Ranking',
    value: 'ranking'
  }, {
    name: 'Most/Least',
    value: 'most/least'
  }, {
    name: 'Multi',
    value: 'multi'
  }];
  subQuestionType = [{
    name: 'Multiple Choice',
    value: 'multi_choice'
  }, {
    name: 'Rating',
    value: 'rating'
  }, {
    name: 'Ranking',
    value: 'ranking'
  }, {
    name: 'Most/Least',
    value: 'most/least'
  }];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAddQuestionComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private measureManagementService: MeasureManagementService,
    private eLearningService: ELearningManagementService,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.getForm();
  }

  getForm() {
    console.log(this.modalData);

    this.multipleChoiceForm = this.fb.group({
      type: 'multi_choice',
      question: ['', Validators.required],
      media: this.fb.group({
        media_type: '',
        file_name: '',
        time_again: '',
        unlimit: '',
        duration: '',
        vdo_id: '',
        file_url: ''
      }),
      choices: this.fb.array([]),
    })
    this.ratingForm = this.fb.group({
      type: 'rating',
      question: ['', Validators.required],
      length: ['', Validators.required],
      default: [1, Validators.required], // ตอนแรกมีให้เลือก แต่เอาออกแล้วเลยใส่ค่า default เป็น 1
      choices: this.fb.array([]),
    })
    this.rankingForm = this.fb.group({
      type: 'ranking',
      question: ['', Validators.required],
      choices: this.fb.array([]),
    })
    this.mostLeastForm = this.fb.group({
      type: 'most/least',
      question: ['', Validators.required],
      most: ['', Validators.required],
      least: ['', Validators.required],
      media: this.fb.group({
        media_type: '',
        file_name: '',
        time_again: '',
        unlimit: '',
        duration: '',
        vdo_id: '',
        file_url: ''
      }),
      choices: this.fb.array([]),
    })
    this.multiForm = this.fb.group({
      type: 'multi',
      question: ['', Validators.required],
      subType: ['', Validators.required],
      subQuestion: this.fb.array([])
    })

    if (this.modalData.isEdit) {
      this.type = this.modalData.value.TYPE;

      switch (this.type) {
        case 'multi_choice': {
          let group = this.fb.group({
            media_type: this.modalData.value.VALUE[0].media_type ? this.modalData.value.VALUE[0].media.media_type : '',
            file_name: this.modalData.value.VALUE[0].file_name ? this.modalData.value.VALUE[0].media.file_name : '',
            time_again: this.modalData.value.VALUE[0].time_again ? this.modalData.value.VALUE[0].media.time_again : '',
            unlimit: this.modalData.value.VALUE[0].unlimit ? this.modalData.value.VALUE[0].media.unlimit : '',
            file_url: this.modalData.value.VALUE[0].media.file_url ? this.modalData.value.VALUE[0].media.file_url : '',
            duration: this.modalData.value.VALUE[0].media.duration ? this.modalData.value.VALUE[0].media.duration : '',
            vdo_id: this.modalData.value.VALUE[0].media.vdo_id ? this.modalData.value.VALUE[0].media.vdo_id : ''
          })

          this.multipleChoiceForm = this.fb.group({
            type: 'multi_choice',
            question: [this.modalData.value.VALUE[0].question, Validators.required],
            media: group,
            choices: this.fb.array([]),
          })
          break;
        }

        case 'rating': {
          this.ratingForm = this.fb.group({
            type: 'rating',
            question: [this.modalData.value.VALUE[0].question, Validators.required],
            length: [this.modalData.value.VALUE[0].length, Validators.required],
            default: [this.modalData.value.VALUE[0].default, Validators.required],
            choices: this.fb.array([]),
          })
          break;
        }

        case 'ranking': {
          this.rankingForm = this.fb.group({
            type: 'ranking',
            question: [this.modalData.value.VALUE[0].question, Validators.required],
            choices: this.fb.array([]),
          })
          break;
        }

        case 'most/least': {
          let group = this.fb.group({
            media_type: this.modalData.value.VALUE[0].media_type ? this.modalData.value.VALUE[0].media.media_type : '',
            file_name: this.modalData.value.VALUE[0].file_name ? this.modalData.value.VALUE[0].media.file_name : '',
            time_again: this.modalData.value.VALUE[0].time_again ? this.modalData.value.VALUE[0].media.time_again : '',
            unlimit: this.modalData.value.VALUE[0].unlimit ? this.modalData.value.VALUE[0].media.unlimit : '',
            file_url: this.modalData.value.VALUE[0].media.file_url ? this.modalData.value.VALUE[0].media.file_url : '',
            duration: this.modalData.value.VALUE[0].media.duration ? this.modalData.value.VALUE[0].media.duration : '',
            vdo_id: this.modalData.value.VALUE[0].media.vdo_id ? this.modalData.value.VALUE[0].media.vdo_id : ''
          })

          this.mostLeastForm = this.fb.group({
            type: 'most/least',
            most: [this.modalData.value.VALUE[0].most, Validators.required],
            least: [this.modalData.value.VALUE[0].least, Validators.required],
            question: [this.modalData.value.VALUE[0].question, Validators.required],
            media: group,
            choices: this.fb.array([]),
          })
          break;
        }
      }
    }
  }

  getChoicesMedia(e) {
    console.log(e);
    this.choicesMedia = e;
  }

  getQuestionMedia(e) {
    console.log(e);
    this.questionMedia = e;
  }

  getQuestionMediaType(e) {
    console.log(e);
    this.questionMediaType = e;
  }

  addQuastionList(form, isEdit) {
    console.log(form);
    switch (this.type) {
      case 'multi_choice': {
        if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
          alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
          break;
        } else if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }

        form.controls['type'].setValue('multi_choice');
        this.isLoading = true;

        if (this.questionMediaType === 'mp4') {
          this.eLearningService.createVideo(this.questionMedia).pipe(
            map(response => {
              const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
              this.pendingFiles.push(videoFile);
              this.uploadVideoUri = response.body.uri.slice(8);
              this.hashKey = response.body.link.slice(-10);

              return new tus.Upload(this.pendingFiles[0].video, {
                uploadUrl: this.pendingFiles[0].uploadURI,
                endpoint: this.pendingFiles[0].uploadURI,
                retryDelays: [0, 1000, 3000, 5000],
                onError: error => {
                  // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                  return of(null)
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                  this.percentage = ((bytesUploaded / bytesTotal) * 100);
                  const percentage = ((bytesUploaded / bytesTotal) * 100);
                  // console.log(bytesUploaded, bytesTotal, percentage + '%');
                },
                onSuccess: () => {
                  // console.log('Videos uploaded successfully');

                  form.controls['media'].patchValue({
                    file_name: this.uploadVideoUri
                  });
                  form.controls['media'].updateValueAndValidity();
                  this.questionMedia = '';

                  // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
                  if (!this.modalData.id) {
                    const data = {
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : '',
                      choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                    };

                    this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
                      map(res => {
                        if (res.success) {
                          this.dialogRef.close({ status: true });
                          this.isLoading = false;
                        }
                      }),
                      catchError((err) => {
                        alert(err.error.message)
                        this.isLoading = false;
                        return of(null);
                      })
                    ).subscribe();

                  } else {
                    const data = {
                      id: this.modalData.id,
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : '',
                      choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                    };

                    this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
                      map(res => {
                        if (res.success) {
                          this.isLoading = false;
                          this.dialogRef.close({ status: true });
                        }
                      }),
                      catchError((err) => {
                        alert(err.error.message)
                        this.isLoading = false;
                        return of(null);
                      })
                    ).subscribe();
                  }
                }
              }).start();
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
          break;
        } else {
          // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
          if (!this.modalData.id) {
            const data = {
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : '',
              choicesMedia: this.choicesMedia ? this.choicesMedia : ''
            }

            this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
              map(res => {
                if (res.success) {
                  this.isLoading = false;
                  this.dialogRef.close({ status: true });
                }
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
          } else {
            const data = {
              id: this.modalData.id,
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : '',
              choicesMedia: this.choicesMedia ? this.choicesMedia : ''
            };

            this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
              map(res => {
                if (res.success) {
                  this.isLoading = false;
                  this.dialogRef.close({ status: true });
                }
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
          }
        }
        break;
      }

      case 'rating': {
        // console.log(form);

        form.controls['type'].setValue('rating');

        // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
        if (!this.modalData.id) {
          const data = {
            measure_id: this.modalData.measureId
          }

          this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
            map(res => {
              this.isLoading = true;
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe()
        } else {
          const data = {
            id: this.modalData.id,
            measure_id: this.modalData.measureId
          };

          this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
            map(res => {
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
        }
        break;
      }

      case 'ranking': {
        if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }
        // console.log(form);

        form.controls['type'].setValue('ranking');

        // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
        if (!this.modalData.id) {
          const data = {
            measure_id: this.modalData.measureId
          }

          this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
            map(res => {
              this.isLoading = true;
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe()
          break;
        } else {
          const data = {
            id: this.modalData.id,
            measure_id: this.modalData.measureId
          };

          this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
            map(res => {
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
        }
        break;
      }

      case 'most/least': {
        if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
          alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
          break;
        } else if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }

        form.controls['type'].setValue('most/least');
        this.isLoading = true;

        if (this.questionMediaType === 'mp4') {

          this.eLearningService.createVideo(this.questionMedia).pipe(
            map(response => {
              const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
              this.pendingFiles.push(videoFile);
              this.uploadVideoUri = response.body.uri.slice(8);
              this.hashKey = response.body.link.slice(-10);

              return new tus.Upload(this.pendingFiles[0].video, {
                uploadUrl: this.pendingFiles[0].uploadURI,
                endpoint: this.pendingFiles[0].uploadURI,
                retryDelays: [0, 1000, 3000, 5000],
                onError: error => {
                  // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                  return of(null)
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                  this.percentage = ((bytesUploaded / bytesTotal) * 100);
                  const percentage = ((bytesUploaded / bytesTotal) * 100);
                  // console.log(bytesUploaded, bytesTotal, percentage + '%');
                },
                onSuccess: () => {
                  // console.log('Videos uploaded successfully');

                  form.controls['media'].patchValue({
                    file_name: this.uploadVideoUri
                  });
                  form.controls['media'].updateValueAndValidity();
                  this.questionMedia = '';

                  // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
                  if (!this.modalData.id) {
                    const data = {
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : ''
                    };

                    this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
                      map(res => {
                        if (res.success) {
                          this.isLoading = false;
                          this.dialogRef.close({ status: true });
                        }
                      }),
                      catchError((err) => {
                        alert(err.error.message)
                        this.isLoading = false;
                        return of(null);
                      })
                    ).subscribe();

                  } else {
                    const data = {
                      id: this.modalData.id,
                      measure_id: this.modalData.measureId,
                      questionMedia: this.questionMedia ? this.questionMedia : ''
                    };

                    this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
                      map(res => {
                        if (res.success) {
                          this.isLoading = false;
                          this.dialogRef.close({ status: true });
                        }
                      }),
                      catchError((err) => {
                        alert(err.error.message)
                        this.isLoading = false;
                        return of(null);
                      })
                    ).subscribe();
                  }
                }
              }).start();
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
          break;
        } else {
          // เช็คกรณีแก้ไขแล้วเปลี่ยนประเภท เช็คจาก id ของข้อ
          if (!this.modalData.id) {
            const data = {
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : ''
            }

            this.measureManagementService.createDetailMeasureByType(form.value, data).pipe(
              map(res => {
                if (res.success) {
                  this.isLoading = false;
                  this.dialogRef.close({ status: true });
                }
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
          } else {
            const data = {
              id: this.modalData.id,
              measure_id: this.modalData.measureId,
              questionMedia: this.questionMedia ? this.questionMedia : ''
            };

            this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
              map(res => {
                if (res.success) {
                  this.isLoading = false;
                  this.dialogRef.close({ status: true });
                }
              }),
              catchError((err) => {
                alert(err.error.message)
                this.isLoading = false;
                return of(null);
              })
            ).subscribe();
          }
        }
        break;
      }

      case 'Multi': {
        // console.log(this.multiFormArray);

        if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.unlimit && !form.value.time_again)) {
          alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้ Multi');
        } else if (this.multiFormArray.controls.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป Multi');
        }
        break;
      }
    }
  }


  editQuestionList(form, isEdit) {
    console.log(form. isEdit)
    switch (this.type) {
      case 'multi_choice': {
        console.log(this.type);
        if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
          alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
          break;
        } else if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }

        form.controls['type'].setValue('multi_choice');
        this.isLoading = true;

        if (this.questionMediaType === 'mp4') {
          this.eLearningService.createVideo(this.questionMedia).pipe(
            map(response => {
              const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
              this.pendingFiles.push(videoFile);
              this.uploadVideoUri = response.body.uri.slice(8);
              this.hashKey = response.body.link.slice(-10);

              return new tus.Upload(this.pendingFiles[0].video, {
                uploadUrl: this.pendingFiles[0].uploadURI,
                endpoint: this.pendingFiles[0].uploadURI,
                retryDelays: [0, 1000, 3000, 5000],
                onError: error => {
                  // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                  return of(null)
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                  this.percentage = ((bytesUploaded / bytesTotal) * 100);
                  const percentage = ((bytesUploaded / bytesTotal) * 100);
                  // console.log(bytesUploaded, bytesTotal, percentage + '%');
                },
                onSuccess: () => {
                  // console.log('Videos uploaded successfully');

                  form.controls['media'].patchValue({
                    file_name: this.uploadVideoUri
                  });
                  form.controls['media'].updateValueAndValidity();
                  this.questionMedia = '';

                  const data = {
                    id: this.modalData.value.ID,
                    measure_id: this.modalData.measureId,
                    questionMedia: this.questionMedia ? this.questionMedia : '',
                    choicesMedia: this.choicesMedia ? this.choicesMedia : ''
                  };

                  console.log(form.value, data);

                  this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
                    map(res => {
                      // console.log(res);
                      if (res.success) {
                        this.isLoading = false;
                        this.dialogRef.close({ status: true });
                      }
                    }),
                    catchError((err) => {
                      alert(err.error.message)
                      this.isLoading = false;
                      return of(null);
                    })
                  ).subscribe();
                }
              }).start();
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
          break;
        } else {
          const data = {
            id: this.modalData.value.ID,
            measure_id: this.modalData.measureId,
            questionMedia: this.questionMedia ? this.questionMedia : '',
            choicesMedia: this.choicesMedia ? this.choicesMedia : ''
          }

          if (form.value.media.vdo_id) {
            form.value.media.file_name = form.value.media.vdo_id;
          }

          this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
            map(res => {
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
        }
        break;
      }

      case 'rating': {
        // console.log(form);

        form.controls['type'].setValue('rating');

        const data = {
          id: this.modalData.value.ID,
          measure_id: this.modalData.measureId
        }

        this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
          map(res => {
            // console.log(res);

            this.isLoading = true;
            if (res.success) {
              this.isLoading = false;
              this.dialogRef.close({ status: true });
            }
          }),
          catchError((err) => {
            alert(err.error.message)
            this.isLoading = false;
            return of(null);
          })
        ).subscribe()
        break;
      }

      case 'ranking': {
        if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }
        // console.log(form);

        form.controls['type'].setValue('ranking');

        const data = {
          id: this.modalData.value.ID,
          measure_id: this.modalData.measureId
        };

        this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
          map(res => {
            if (res.success) {
              this.isLoading = false;
              this.dialogRef.close({ status: true });
            }
          }),
          catchError((err) => {
            alert(err.error.message)
            this.isLoading = false;
            return of(null);
          })
        ).subscribe();
        break;
      }

      case 'most/least': {
        if ((this.questionMediaType === 'mp4' || this.questionMediaType === 'mp3' || this.questionMediaType === 'wav') && (!form.value.media.unlimit && !form.value.media.time_again)) {
          alert('กรุณาใส่จำนวนรอบที่สามารถเปิดซ้ำได้');
          break;
        } else if (form.value.choices.length <= 1) {
          alert('กรุณาใส่ตัวเลือก 2 ตัวเลือกขึ้นไป');
          break;
        }

        form.controls['type'].setValue('most/least');
        this.isLoading = true;

        if (this.questionMediaType === 'mp4') {
          this.eLearningService.createVideo(this.questionMedia).pipe(
            map(response => {
              const videoFile = new uploadFiles(this.questionMedia, response.body.link, response.body.upload.upload_link);
              this.pendingFiles.push(videoFile);
              this.uploadVideoUri = response.body.uri.slice(8);
              this.hashKey = response.body.link.slice(-10);

              return new tus.Upload(this.pendingFiles[0].video, {
                uploadUrl: this.pendingFiles[0].uploadURI,
                endpoint: this.pendingFiles[0].uploadURI,
                retryDelays: [0, 1000, 3000, 5000],
                onError: error => {
                  // console.log('Failed: ' + this.pendingFiles[0].video.name + error);
                  return of(null)
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                  this.percentage = ((bytesUploaded / bytesTotal) * 100);
                  const percentage = ((bytesUploaded / bytesTotal) * 100);
                  // console.log(bytesUploaded, bytesTotal, percentage + '%');
                },
                onSuccess: () => {
                  // console.log('Videos uploaded successfully');

                  form.controls['media'].patchValue({
                    file_name: this.uploadVideoUri
                  });
                  form.controls['media'].updateValueAndValidity();
                  this.questionMedia = '';

                  const data = {
                    id: this.modalData.id,
                    measure_id: this.modalData.measureId,
                    questionMedia: this.questionMedia ? this.questionMedia : ''
                  };

                  this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
                    map(res => {
                      if (res.success) {
                        this.isLoading = false;
                        this.dialogRef.close({ status: true });
                      }
                    }),
                    catchError((err) => {
                      alert(err.error.message)
                      this.isLoading = false;
                      return of(null);
                    })
                  ).subscribe();
                }
              }).start();
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
          break;
        } else {
          const data = {
            id: this.modalData.id,
            measure_id: this.modalData.measureId,
            questionMedia: this.questionMedia ? this.questionMedia : ''
          };

          // console.log(form.value);


          if (form.value.media.vdo_id) {
            form.value.media.file_name = form.value.media.vdo_id;
          }

          this.measureManagementService.editMeasureQuestionByType(form.value, data).pipe(
            map(res => {
              if (res.success) {
                this.isLoading = false;
                this.dialogRef.close({ status: true });
              }
            }),
            catchError((err) => {
              alert(err.error.message)
              this.isLoading = false;
              return of(null);
            })
          ).subscribe();
        }
        break;
      }
    }
  }

  setType(t) {
    this.type = t.target.value;
    this.modalData.isEdit = false;
    this.questionMedia = null;
    this.questionMediaType = null;

    this.getForm();
    this.multipleChoiceFormArray.clear();
    this.rankingFormArray.clear();
    this.ratingFormArray.clear();
    this.mostLeastFormArray.clear();
    this.multiFormArray.clear();

    this.multipleChoiceForm.reset();
    this.rankingForm.reset();
    this.ratingForm.reset();
    this.mostLeastForm.reset();
    this.multiForm.reset();
    console.log(this.multipleChoiceForm);
    console.log(this.rankingForm);
    console.log(this.ratingForm);
    console.log(this.mostLeastForm);
    console.log(this.multiForm);
  }

  setSubType(t) {
    this.subType = t.target.value;
  }

  get multipleChoiceFormArray(): FormArray {
    return this.multipleChoiceForm.get('choices') as FormArray;
  }

  get ratingFormArray(): FormArray {
    return this.ratingForm.get('choices') as FormArray;
  }

  get rankingFormArray(): FormArray {
    return this.rankingForm.get('choices') as FormArray;
  }

  get mostLeastFormArray(): FormArray {
    return this.mostLeastForm.get('choices') as FormArray;
  }

  get multiFormArray(): FormArray {
    return this.multiForm.get('subQuestion') as FormArray;
  }

  closeModal() {
    const response = {
      status: false,
    }

    this.dialogRef.close(response);
  }
}
